import React from "react";
import { columnFooterGeneratorType, columnsVisibleType } from "../../../../common/types/search/results";
import { pagingType } from "../../../../common/types/search/search";

interface SearchResultsFooterRowProps {
	columnsVisible: columnsVisibleType;
	paging: pagingType;
	columnFooterGenerator?: columnFooterGeneratorType;
}

export function SearchResultsFooterRow({
	columnsVisible,
	paging,
	columnFooterGenerator,
}: SearchResultsFooterRowProps) {
	if (!columnFooterGenerator) {
		return null;
	}

	return (
		<tfoot>
			<tr>{columnFooterGenerator(columnsVisible, paging)}</tr>
		</tfoot>
	);
}
